import { SxProps, Theme } from "@mui/material";

export const root: SxProps<Theme> = (theme) => ({
	display: "flex",
	alignItems: "center",
	padding: theme.spacing(3),
	justifyContent: "space-between",
	backgroundColor: theme.palette.background.paper,
});
